import { useEffect, useState } from "react";

// Compact layout (Review 17, C62): on windows under about 1440×800 (a 1366×768 Chromebook with the
// browser bar showing gets 1366×635) the workspace gives its room to the game and the helper: the
// Cards/Code/Files panel folds into a tools rail, the console into one line.

export const COMPACT_WIDTH = 1440;
export const COMPACT_HEIGHT = 800;
/** Under this height a one-time tip suggests the Chromebook's full-screen key. */
export const SHORT_HEIGHT = 700;

const read = () => ({ w: window.innerWidth, h: window.innerHeight });

/** The window's size, kept up to date. */
export function useWindowSize(): { w: number; h: number } {
  const [size, setSize] = useState(read);
  useEffect(() => {
    let frame = 0;
    const onResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setSize((s) => {
        const n = read();
        return n.w === s.w && n.h === s.h ? s : n;
      }));
    };
    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return size;
}

/** True when the window is small enough for the compact workspace. */
export function useCompact(): boolean {
  const { w, h } = useWindowSize();
  return w < COMPACT_WIDTH || h < COMPACT_HEIGHT;
}
